import React from "react";
import * as Mui from "@mui/material";
import { BlobProvider } from "@react-pdf/renderer";
import { themes } from "services/constants";
import { Loader } from "components/Loader";
import { SAMPLE_PAYSLIP_DATA } from "../../../../PayslipTemplates/templates";

export const TemplatePreviewDialog = ({
  open,
  template,
  isActive,
  isApplying = false,
  onApply,
  onClose,
  companyName,
  companyAddress,
}) => {
  if (!template) return null;
  const PreviewDocument = template.SingleDocument;
  // The rest of the sample payslip stays fixture data — only the company
  // identity should reflect whichever company is selected in the topbar.
  const previewPayslipData = {
    ...SAMPLE_PAYSLIP_DATA,
    company_name: companyName || SAMPLE_PAYSLIP_DATA.company_name,
    company_address: companyAddress || SAMPLE_PAYSLIP_DATA.company_address,
  };

  return (
    <Mui.Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <Mui.DialogTitle sx={{ fontWeight: 700 }}>
        {template.name}
        <Mui.Typography variant="body2" color="text.secondary">
          {template.description}
        </Mui.Typography>
      </Mui.DialogTitle>
      <Mui.DialogContent
        dividers
        sx={{ p: 0, height: "72vh", backgroundColor: "#f5f5fd" }}
      >
        <BlobProvider
          key={template.id}
          document={
            <PreviewDocument payslipData={previewPayslipData} isPreview />
          }
        >
          {({ url, loading }) =>
            loading || !url ? (
              <Loader info="Preparing preview..." />
            ) : (
              <iframe
                src={url}
                title="Template Preview"
                style={{ width: "100%", height: "100%", border: "none" }}
              />
            )
          }
        </BlobProvider>
      </Mui.DialogContent>
      <Mui.DialogActions sx={{ p: 2 }}>
        <Mui.Button
          onClick={onClose}
          disabled={isApplying}
          sx={{ color: themes?.grayColor }}
        >
          Cancel
        </Mui.Button>
        <Mui.Button
          variant="contained"
          onClick={onApply}
          disabled={isActive || isApplying}
          startIcon={
            isApplying ? (
              <Mui.CircularProgress size={16} color="inherit" />
            ) : null
          }
          sx={{
            background: themes?.primaryButton,
            color: themes?.headLine,
            textTransform: "capitalize",
            "&:hover": { backgroundColor: themes?.primaryButton },
          }}
        >
          {isActive ? "Already Applied" : isApplying ? "Applying..." : "Apply"}
        </Mui.Button>
      </Mui.DialogActions>
    </Mui.Dialog>
  );
};
